import { render, staticRenderFns } from "./ProfileEditDialog.vue?vue&type=template&id=2fef093a&scoped=true"
import script from "./ProfileEditDialog.vue?vue&type=script&lang=js"
export * from "./ProfileEditDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fef093a",
  null
  
)

export default component.exports